import React from "react";
import { Box, Typography } from "@mui/material";
import { LocationOn } from "@mui/icons-material";

const TILE_SIZE = 256;
const ZOOM = 11;

// Convierte lat/lng a coordenadas de tile (con fracción) de OpenStreetMap
const toTileCoords = (lat, lng, zoom) => {
  const n = 2 ** zoom;
  const latRad = (lat * Math.PI) / 180;
  const x = ((lng + 180) / 360) * n;
  const y = ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * n;
  return { x, y, n };
};

// Recorte de mapa (3x3 tiles) centrado en la ubicación, con un pin encima
const LoginMap = ({ lat, lng, label, height = 130 }) => {
  if (typeof lat !== "number" || typeof lng !== "number") return null;

  const { x, y, n } = toTileCoords(lat, lng, ZOOM);
  const tileX = Math.floor(x);
  const tileY = Math.floor(y);
  const offsetX = TILE_SIZE + (x - tileX) * TILE_SIZE;
  const offsetY = TILE_SIZE + (y - tileY) * TILE_SIZE;

  const tiles = [];
  for (let dy = -1; dy <= 1; dy += 1) {
    for (let dx = -1; dx <= 1; dx += 1) {
      const ty = tileY + dy;
      if (ty < 0 || ty >= n) continue;
      const tx = (((tileX + dx) % n) + n) % n;
      tiles.push({
        key: `${dx}_${dy}`,
        src: `https://tile.openstreetmap.org/${ZOOM}/${tx}/${ty}.png`,
        left: (dx + 1) * TILE_SIZE,
        top: (dy + 1) * TILE_SIZE,
      });
    }
  }

  const osmUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${ZOOM}/${lat}/${lng}`;

  return (
    <Box
      component="a"
      href={osmUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      sx={{
        display: "block",
        position: "relative",
        height,
        mt: 1,
        borderRadius: "8px",
        overflow: "hidden",
        bgcolor: "#1b1f24",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          width: TILE_SIZE * 3,
          height: TILE_SIZE * 3,
          transform: `translate(${-offsetX}px, ${-offsetY}px)`,
        }}
      >
        {tiles.map((tile) => (
          <Box
            key={tile.key}
            component="img"
            src={tile.src}
            alt=""
            loading="lazy"
            draggable={false}
            sx={{ position: "absolute", left: tile.left, top: tile.top, width: TILE_SIZE, height: TILE_SIZE }}
          />
        ))}
      </Box>
      <LocationOn
        sx={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -100%)",
          fontSize: 34,
          color: "#ff3b5c",
          filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.5))",
        }}
      />
      <Typography
        component="span"
        sx={{
          position: "absolute",
          right: 0,
          bottom: 0,
          px: 0.6,
          fontSize: "0.62rem",
          color: "#333",
          bgcolor: "rgba(255,255,255,0.8)",
          borderTopLeftRadius: "4px",
        }}
      >
        © OpenStreetMap
      </Typography>
    </Box>
  );
};

export default LoginMap;
